export default {"src":"/_next/static/media/logo.6fa0aa05.svg","height":117,"width":185,"blurWidth":0,"blurHeight":0};